export const CARD_VARIANTS = {
  ACTIVE: "active",
  SELECTED: "selected",
  PAST: "past",
} as const;
